import {
  GETTER_BIRTHDATE,
  GETTER_EMAIL,
  GETTER_FIRSTNAME,
  GETTER_LASTNAME,
  GETTER_MIDDLENAME,
  GETTER_MOBILENUMBER,
  GETTER_TOKENS,
  GETTER_ACCOUNT_ID,
  GETTER_PATIENTS,
  GETTER_DOCTORS_BY_ID,
  GETTER_DOCTORS_BY_USER_TAG,
  GETTER_DOCTOR_PATIENT_PARTNER,
  GETTER_INVITE_CODE_URL_TOKEN,
  MUTATE_ACCOUNT,
  MUTATE_REMOVE_TOKEN,
  MUTATE_SET_INVITE_CODE_TOKEN,
  MUTATE_REMOVE_INVITE_CODE_TOKEN,
  MUTATE_CLEAR_ACCOUNT_MODULE,
  ACTION_EDIT_ACCOUNT,
  ACTION_REMOVE_TOKEN,
  ACTION_SET_INVITE_CODE_TOKEN,
  ACTION_REMOVE_INVITE_CODE_TOKEN,
  ACTION_CLEAR_ACCOUNT_MODULE,
  GETTER_DOCTOR_PATIENT_PARTNER_BY_TOKEN,
} from './types';
import {isEmpty} from '@/utils';
import {getTokenProp} from '@/utils/access-token';

const getDefaultAccountModule = () => {
  return {
    birthdate: '',
    email: '',
    firstname: '',
    lastname: '',
    middlename: '',
    mobilenumber: '',
    tokens: null,
    urlInviteCodeToken: null,
  }
}
const state = getDefaultAccountModule();

const getters = {
  [GETTER_BIRTHDATE]: ({birthdate}) => birthdate,
  [GETTER_EMAIL]: ({email}) => email,
  [GETTER_FIRSTNAME]: ({firstname}) => firstname,
  [GETTER_LASTNAME]: ({lastname}) => lastname,
  [GETTER_MIDDLENAME]: ({middlename}) => middlename,
  [GETTER_MOBILENUMBER]: ({mobilenumber}) => mobilenumber,
  [GETTER_ACCOUNT_ID]: () => getTokenProp('accountid'),
  [GETTER_INVITE_CODE_URL_TOKEN]: ({urlInviteCodeToken}, getters) => {
    if (getters[GETTER_TOKENS]) {
      const alreadyExists = !!getters[GETTER_TOKENS].find((el) => el.token === urlInviteCodeToken);

      return alreadyExists ? null : urlInviteCodeToken;
    } else {
      return null;
    }

  },
  [GETTER_TOKENS]: ({tokens}) => {
    if (!tokens) return null;

    return tokens.filter(({accesstoken}) => !isEmpty(accesstoken))
                 .map(tokenItem => {
                    return {
                      ...tokenItem,
                      localStorageKey: `${tokenItem.doctor.id}-${tokenItem.patient.id}`,
                    }
                  });
  },
  [GETTER_PATIENTS]: (state, getters) => {
    if (!getters[GETTER_TOKENS]) return null;

    const patients = {};

    getters[GETTER_TOKENS].forEach(({doctor, patient}) => {
      if (!patients[patient.id]) {
        patients[patient.id] = {
          ...patient,
          doctor,
        };
      }
    });

    return patients;
  },
  [GETTER_DOCTORS_BY_ID]: (state, getters) => {
    if (!getters[GETTER_TOKENS]) return null;

    const doctors = {};

    getters[GETTER_TOKENS].forEach(({doctor}) => {
      if (!doctors[doctor.id]) {
        doctors[doctor.id] = doctor;
      }
    });

    return doctors;
  },
  [GETTER_DOCTORS_BY_USER_TAG]: (state, getters) => {
    if (!getters[GETTER_TOKENS]) return null;

    const doctors = {};

    getters[GETTER_TOKENS].forEach(({doctor}) => {
      if (!doctors[doctor.usertag]) {
        doctors[doctor.usertag] = doctor;
      }
    });

    return doctors;
  },
  [GETTER_DOCTOR_PATIENT_PARTNER]: (state, getters) => {
    if (!getters[GETTER_TOKENS]) return null;

    const partners = {};

    getters[GETTER_TOKENS].forEach(tokenItem => {
      partners[tokenItem.accesstoken] = tokenItem;
    });

    return partners;
  },

  [GETTER_DOCTOR_PATIENT_PARTNER_BY_TOKEN]: (state, getters) => {
    if (!getters[GETTER_TOKENS]) return null;

    const partners = {};

    getters[GETTER_TOKENS].forEach(tokenItem => {
      partners[tokenItem.token] = tokenItem;
    });

    return partners;
  },
};

const actions = {
  /**
   *
   * @param {Object} newValues - [account prop to be edit]: <value>
   */
  [ACTION_EDIT_ACCOUNT]: ({commit}, newValues) => {
    commit(MUTATE_ACCOUNT, newValues);
  },
  /**
   *
   * @param {string[]} tokensToRemove
   */
  [ACTION_REMOVE_TOKEN]: ({commit}, tokensToRemove) => {
    commit(MUTATE_REMOVE_TOKEN, tokensToRemove);
  },
  [ACTION_SET_INVITE_CODE_TOKEN]: ({commit}, newToken) => {
    commit(MUTATE_SET_INVITE_CODE_TOKEN, newToken);
  },
  [ACTION_REMOVE_INVITE_CODE_TOKEN]: ({commit}) => {
    commit(MUTATE_REMOVE_INVITE_CODE_TOKEN);
  },
  [ACTION_CLEAR_ACCOUNT_MODULE]: ({commit}) => {
    commit(MUTATE_CLEAR_ACCOUNT_MODULE);
  }
};

const mutations = {
  [MUTATE_ACCOUNT]: (state, newValues) => {
    Object.keys(newValues).forEach((newValueProp) => {
      state[newValueProp] = newValues[newValueProp];
    });
  },
  /**
   *
   * @param {string[]} tokensToRemove
   */
  [MUTATE_REMOVE_TOKEN]: (state, tokensToRemove) => {
    for (let i = state.tokens.length - 1; i >= 0; i--) {
      const {token} = state.tokens[i];

      if (tokensToRemove.includes(token)) {
        state.tokens.splice(i, 1);
      }
    }
  },
  [MUTATE_SET_INVITE_CODE_TOKEN]: (state, newToken) => {
    state.urlInviteCodeToken = newToken;
  },
  [MUTATE_REMOVE_INVITE_CODE_TOKEN]: (state) => {
    state.urlInviteCodeToken = null;
  },
  [MUTATE_CLEAR_ACCOUNT_MODULE]: (state) => {
    Object.assign(state, getDefaultAccountModule());
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
